import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../components/common/Button";

// The frame every carousel tool panel shares: the panel's own controls, then
// Reset · Cancel · Apply.
//   Desktop (md and up): a grey box between the toolbar and the slide.
//   Phone: a sheet fixed to the bottom of the screen, at most 40% of its
//   height, so the slide above stays visible while adjusting. The content
//   scrolls inside the sheet and the buttons stay at its bottom.
//   title    shown on the phone sheet only (on desktop the pressed toolbar
//            button already says which panel is open)
//   onReset  (optional) back to the starting values; Cancel can still undo it
//   onCancel (optional) back to the values from when the panel opened
//   onApply  closes the panel and keeps the changes
export default function CarouselPanel({
  title,
  children,
  onReset,
  onCancel,
  onApply,
}) {
  const { t } = useTranslation();

  return (
    <div
      role="region"
      aria-label={title}
      className="bg-black-30 border-x border-gray-200 p-3 space-y-3
        fixed inset-x-0 bottom-0 z-40 max-h-[40vh] overflow-y-auto
        rounded-t-2xl border-t shadow-lg
        md:static md:z-auto md:max-h-none md:overflow-visible
        md:rounded-none md:border-t-0 md:shadow-none"
    >
      {/* Phone only: grab bar and the panel name */}
      <div className="md:hidden flex flex-col items-center gap-2">
        <span className="w-10 h-1 rounded-full bg-black-100" aria-hidden="true" />
        {title && (
          <span className="self-start font-bold text-black-800">{title}</span>
        )}
      </div>

      {children}

      <div
        className="flex justify-end items-center gap-2 pt-2
          sticky bottom-0 -mx-3 -mb-3 px-3 pb-3 bg-black-30
          md:static md:mx-0 md:mb-0 md:px-0 md:pb-0"
      >
        {onReset && (
          <Button variant="link" onClick={onReset} className="mr-2">
            {t("carousel.reset")}
          </Button>
        )}
        {onCancel && (
          <Button
            variant="ghost"
            onClick={onCancel}
            className="!text-sm !py-1.5 !px-4"
          >
            {t("buttons.cancel")}
          </Button>
        )}
        <Button
          variant="primary"
          onClick={onApply}
          className="!text-sm !py-1.5 !px-4"
        >
          {t("logoEditor.apply")}
        </Button>
      </div>
    </div>
  );
}